module.exports = __webpack_public_path__ + "img/615.Broken_abinet.89bef215.svg";